'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$DeleteTwoFactorAuthRequest(id) {
  this.M3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.M3 = id;
}
export { $c_Lpresto_types$proto$DeleteTwoFactorAuthRequest as $c_Lpresto_types$proto$DeleteTwoFactorAuthRequest };
$p = $c_Lpresto_types$proto$DeleteTwoFactorAuthRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$DeleteTwoFactorAuthRequest;
/** @constructor */
function $h_Lpresto_types$proto$DeleteTwoFactorAuthRequest() {
}
export { $h_Lpresto_types$proto$DeleteTwoFactorAuthRequest as $h_Lpresto_types$proto$DeleteTwoFactorAuthRequest };
$h_Lpresto_types$proto$DeleteTwoFactorAuthRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DeleteTwoFactorAuthRequest"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.M3;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 1);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$DeleteTwoFactorAuthRequest)) {
    var this$1 = this.M3;
    var b = x$0.M3;
    return ((this$1.e === b.e) && (this$1.f === b.f));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "DeleteTwoFactorAuthRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.M3;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$DeleteTwoFactorAuthRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.l3)));
}
export { $isArrayOf_Lpresto_types$proto$DeleteTwoFactorAuthRequest as $isArrayOf_Lpresto_types$proto$DeleteTwoFactorAuthRequest };
var $d_Lpresto_types$proto$DeleteTwoFactorAuthRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$DeleteTwoFactorAuthRequest, "presto.types$proto$DeleteTwoFactorAuthRequest", ({
  l3: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$DeleteTwoFactorAuthRequest as $d_Lpresto_types$proto$DeleteTwoFactorAuthRequest };
//# sourceMappingURL=presto.types$proto$-Delete-Two-Factor-Auth-Request.js.map
